import { render, staticRenderFns } from "./TodoTask.vue?vue&type=template&id=513803fa"
import script from "./TodoTask.vue?vue&type=script&lang=js"
export * from "./TodoTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports